import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'

export const EventCategoryInput = ({ input }) => (
  <input {...input} className='form-control' placeholder='Event Category' />
)

EventCategoryInput.propTypes = {
  input: PropTypes.any
}

export const EventActionInput = ({ input }) => (
  <input {...input} className='form-control' placeholder='Event Action' />
)

EventActionInput.propTypes = {
  input: PropTypes.any
}

export const EventLabelInput = ({ input }) => (
  <input {...input} className='form-control' placeholder='Event Label' />
)

EventLabelInput.propTypes = {
  input: PropTypes.any
}

const GoogleAnalyticsTrackEventFields = ({ name }) => (
  <div className='row'>
    <div className='col-sm-4'>
      <Field
        component={EventCategoryInput}
        label='Event Category'
        name={`${name}.eventCategory`}
      />
    </div>
    <div className='col-sm-4'>
      <Field
        component={EventActionInput}
        label='Event Action'
        name={`${name}.eventAction`}
      />
    </div>
    <div className='col-sm-4'>
      <Field
        component={EventLabelInput}
        label='Event Label'
        name={`${name}.eventLabel`}
      />
    </div>
  </div>
)

GoogleAnalyticsTrackEventFields.propTypes = {
  name: PropTypes.string
}

export default GoogleAnalyticsTrackEventFields



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-triggers-actions/actions/twitter/google-analytics-track-event/index.js